import ApiService from '@/services/core/api.service'

const RequirementService = {
  async upload (payload) {
    const header = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return ApiService.post('dsm/requirements/upload', payload, header)
  },

  async removeAllFile (filePath) {
    return ApiService.delete(`dsm/requirements/remove-all-file?path=${filePath}`)
  },

  async removeFile (filePath, fileName) {
    return ApiService.delete(`dsm/requirements/remove-file?path=${filePath}&name=${fileName}`)
  }
}

export default RequirementService
